/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import { md1 } from 'vuetify/blueprints';
import { aliases as baseAliases, mdi } from 'vuetify/iconsets/mdi';
import { VFileUpload, VFileUploadItem } from 'vuetify/labs/VFileUpload';
import { VNumberInput } from 'vuetify/labs/VNumberInput';
import { Ripple } from 'vuetify/directives';

// Composables
import { createVuetify } from 'vuetify';
import {
  VSelect,
  VTextField,
  VExpandTransition,
  VForm,
  VBtn,
  VCheckbox,
  VTextarea,
  VIcon,
  VCol,
  VRow,
  VList,
  VListItem,
  VListItemTitle,
  VListItemSubtitle,
  VDivider,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions,
  VImg,
  VListGroup,
  VProgressLinear,
  VProgressCircular,
  VSwitch,
  VSheet,
  VSnackbar,
  VTable,
  VAvatar,
  VDialog,
  VDialogTransition,
  VTooltip,
  VResponsive,
  VRadio,
  VRadioGroup,
  VAlert,
  VCombobox,
  VSlider,
  VSlideGroupItem,
  VSlideGroup,
  VChip,
  VSpacer,
  VToolbar,
  VMenu,
  VSkeletonLoader,
  VApp,
  VMain,
  VContainer,
  VAppBar,
  VToolbarTitle,
  VAlertTitle,
  VBanner,
  VOtpInput,
  VInput,
  VExpansionPanels,
  VExpansionPanel,
  VExpansionPanelTitle,
  VExpansionPanelText,
  VAutocomplete,
  VCardSubtitle
} from 'vuetify/components';

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  components: {
    VSelect,
    VForm,
    VTextField,
    VNumberInput,
    VTextarea,
    VBtn,
    VCheckbox,
    VExpandTransition,
    VIcon,
    VCol,
    VRow,
    VList,
    VListItem,
    VListItemTitle,
    VListItemSubtitle,
    VDivider,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
    VImg,
    VListGroup,
    VProgressLinear,
    VProgressCircular,
    VSwitch,
    VSheet,
    VTable,
    VAvatar,
    VSnackbar,
    VDialog,
    VTooltip,
    VDialogTransition,
    VResponsive,
    VRadio,
    VRadioGroup,
    VAlert,
    VCombobox,
    VSlider,
    VSlideGroupItem,
    VSlideGroup,
    VChip,
    VFileUpload,
    VFileUploadItem,
    VSpacer,
    VToolbar,
    VMenu,
    VSkeletonLoader,
    VApp,
    VMain,
    VContainer,
    VAppBar,
    VToolbarTitle,
    VAlertTitle,
    VBanner,
    VOtpInput,
    VInput,
    VExpansionPanels,
    VExpansionPanel,
    VExpansionPanelTitle,
    VExpansionPanelText,
    VAutocomplete,
    VCardSubtitle
  },
  blueprint: md1,
  directives: { Ripple },
  icons: {
    /**
     * To find icons go to https://vuetifyjs.com/en/features/icon-fonts/#mdi-icon-search
     */
    defaultSet: 'mdi',
    aliases: {
      ...baseAliases,
      alertCircle: 'mdi-alert-circle',
      close: 'mdi-close',
      delete: 'mdi-delete',
      checkCircle: 'mdi-check-circle',
      information: 'mdi-information',
    },
    sets: { mdi },
  },
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#4CAF50',
        },
      },
    },
  },
  defaults: {
    VTextField: { variant: 'filled' },
    VSelect: { variant: 'filled' },
    VTextarea: { variant: 'filled' },
  }
});
